export enum ClaimStatus {
    Cancelled,
    Closed,
    Denied,
    Open,
    Pending
}